import { messagesEN } from './lib/intl/en-US';
import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '60c2841af8b233677717a5c0';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
    },
};
